import React from 'react';
import Image from '@react/shared/Image';
const CourseCard = ({ title, image, url, content, price, pinText }) => (React.createElement("div", { className: "grid-column" },
    React.createElement("a", { href: url, className: "card", "data-aos": "animated" },
        React.createElement("div", { className: "card__inner" },
            React.createElement("div", { className: "card__media" },
                React.createElement("div", { className: "card__media-holder" },
                    React.createElement(Image, { image: image, alt: title, ratio: 1, width: 460, className: "card__media-element", cdn: true }))),
            React.createElement("div", { className: "card__content-external" },
                React.createElement("div", { className: "tag tag--blue" }, pinText),
                React.createElement("div", { className: "card__content-internal" },
                    React.createElement("h4", { className: "card__title" }, title),
                    React.createElement("div", { className: "card__intro" }, content),
                    React.createElement("p", { className: "card__blog-detail" },
                        React.createElement("span", { className: "card__price" }, price))))))));
export default CourseCard;
